import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const UseCaseSlider = () => {
    const navigate = useNavigate();
    const cases = [
        {
            title: "Insider Threat Detection",
            content: "Identify anomalous user behavior and data exfiltration attempts before they become breaches. PassiveGuard baselines normal activity and flags deviations instantly.",
            img: "👤",
            route: "/docs/security-operations"
        },
        {
            title: "Cloud Security Monitoring",
            content: "Gain visibility into your AWS, Azure, and GCP logs. Detect misconfigurations, unauthorized access, and insecure storage buckets in real-time.",
            img: "☁️",
            route: "/docs/integration-capabilities"
        },
        {
            title: "Threat Hunting",
            content: "Proactively search through petabytes of data using our high-speed query engine. Pivot from indicators of compromise (IOCs) to root cause in seconds.",
            img: "🎯",
            route: "/docs/security-operations"
        },
        {
            title: "MSP External Scanner",
            content: "Discover tenant-level assets across every customer, automate exposure monitoring, and prioritize remediation with guided fixes that reduce risk fast.",
            img: "🛰️",
            route: "/pricing"
        }
    ];

    const [active, setActive] = useState(0);

    const handleLearnMore = () => {
        navigate(cases[active].route);
    };

    return (
        <section className="feature-section usecase-slider-section">
        <div className="container">
            <h2 className="section-title center">SOLUTIONS & USE CASES</h2>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginBottom: '3rem', flexWrap: 'wrap' }}>
                {cases.map((c, i) => (
                    <button
                        key={i}
                        onClick={() => setActive(i)}
                        className={`gh-btn ${active === i ? 'gh-btn-primary' : ''}`}
                        type="button"
                    >
                        {c.title}
                    </button>
                ))}
            </div>

            <div style={{ 
                background: 'var(--gh-bg-secondary)', 
                border: '1px solid var(--gh-border)', 
                padding: '3rem',
                minHeight: '300px',
                display: 'flex',
                alignItems: 'center',
                overflow: 'hidden'
            }}>
                <AnimatePresence mode="wait">
                    <motion.div
                        key={active}
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -20 }}
                        style={{ display: 'flex', alignItems: 'center', gap: '4rem', width: '100%', flexDirection: 'row' }}
                    >
                         <div style={{ fontSize: '8rem', flex: '0 0 200px', textAlign: 'center' }}>
                            {cases[active].img}
                         </div>
                         <div>
                             <h3 style={{ color: 'var(--gh-text)', fontSize: '2rem', marginBottom: '1.5rem' }}>{cases[active].title}</h3>
                             <p style={{ color: 'var(--gh-text-muted)', fontSize: '1.2rem', lineHeight: '1.8' }}>{cases[active].content}</p>
                             <button className="gh-btn" style={{ marginTop: '2rem' }} onClick={handleLearnMore} type="button">Learn more</button>
                         </div>
                    </motion.div>
                </AnimatePresence>
            </div>
        </div>
        </section>
    );
};

export default UseCaseSlider;
